/* src/app/components/ai-library/ai-library/ai-library.component.scss */
:host {
  flex-direction: column;
}
ng-select {
  width: 35%;
}
.second-level-menu {
  max-width: 280px;
  min-width: 280px;
}
#library-card-list {
  width: 100%;
  height: 150px;
  display: none;
  overflow-y: auto;
  scrollbar-width: none;
}
#library-card-list .notification-list {
  width: 100%;
}
#library-card-list .notification-list .card {
  width: 245px;
  background: #fff;
  border-radius: 10px;
  float: left;
  margin: 5px;
}
#library-card-list .notification-list .card .card-body {
  padding: 0.2rem 0.5rem;
}
#library-card-list .notification-list .card .card-body label {
  font-size: 0.9rem;
  color: #666;
}
#library-card-list .notification-list .card .icon {
  display: none;
}
#library-card-list .notification-list .card.active {
  background: var(--primarylightColor);
  color: #fff;
}
#library-card-list .notification-list .card.active .card-body label {
  color: var(--primaryColor);
}
#library-card-list .notification-list .card.active .icon {
  display: block;
}
@media screen and (max-width: 767px) {
  ng-select {
    width: 100%;
  }
}
/*# sourceMappingURL=ai-library.component.css.map */
